import React from "react";
import "./ItemForm.css";
import { Spring, animated } from 'react-spring/renderprops';
import {Transition} from 'react-spring/renderprops'

const modalFrom = {
  opacity: 0,
  position: 'fixed',
  top: '50%',
  left: '50%',
  marginLeft: '-250px',
  marginTop: '-350px',
}

const modalEnter = {
  opacity: 1,
  position: 'fixed',
  top: '50%',
  left: '50%',
  marginLeft: '-250px',
  marginTop: '-350px',
}


export class ItemForm extends React.Component {
  constructor(props) {
    super(props);
    this.renderModifications = this.renderModifications.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

    handleSubmit(e) {
      const formData = new FormData(e.target);
      let newOrder = {name: this.props.item.name, modifications: [],
      restrictions: []}
      for (let [key, value] of formData.entries()) {
        if(key === 'restrictions') {
          newOrder.restrictions.push(value);
        }
        else {
          let mod = {}
          mod[key] = value;
          newOrder.modifications.push(mod);
        }
      }
      this.props.confirmOrder(newOrder);
      this.props.hideModal();
      this.props.showOrders();
    }
    renderModifications() {
      if(this.props.item.modifications && this.props.item.modifications.length > 0) {
        return (
          <fieldset className = "item-modifications">
            {
              this.props.item.modifications.map(mod => {
                return (
                  <fieldset className = "mod-group">
                    <h3> {Object.keys(mod)[0]} </h3>
                    {mod[Object.keys(mod)[0]].map(option => {
                      return (
                        <div className = "mod-input"> 
                          <input type="radio" id={option} name={Object.keys(mod)[0]} value={option}/>
                          <label for={option}> {option} </label>
                        </div>
                        )
                    })}
                  </fieldset>
                );
              })
            }
          </fieldset>
        );
      }
    }
    renderRestrictions() {
      return (
        <fieldset className = "item-restrictions">
          <div className = "restriction-header">
            {this.props.item.restrictions && <h3> Dietary Modifications </h3> }
            {this.props.item.restrictions && <p> Optional </p> }
          </div>
          {
            this.props.item.restrictions && this.props.item.restrictions.map(option => {
              return (
                <div className = "restriction-input"> 
                  <input type="checkbox" id={option} name="restrictions" value={option}/>
                  <label for={option}> {option} </label>
                </div>
                )
            }) 
          }
        </fieldset>
      )
    }
    render() {
      return (
        <div>
        <Transition
          items={this.props.show}
          from={{ opacity: 1 }}
          enter={{ opacity: 1 }}
          leave={{ opacity: 0 }}
          config={{duration: 100}}>
          {show => show && (props => <div style={props}>
            <div className="shadow" onClick = {this.props.hideModal}> </div>
          </div>)}
          </Transition>
        <Transition
          items={this.props.show}
          from={modalFrom}
          enter={modalEnter}
          leave={modalFrom}
          config={this.props.show ? {delay: 200, duration: 80} : {delay: 0, duration:100}}>
          {show => show && (props => <div style={props}>
                <form className = "item-form" onSubmit = {(e) => {
                  e.preventDefault()
                  this.handleSubmit(e);
                }
                  }>
                  <div className = "form-header">
                    <h2>{this.props.item.name}</h2>
                    <button className = "close-button" onClick = {(e) => {
                      e.preventDefault();
                      this.props.hideModal();
                      }}>  
                    </button>
                  </div>
                  <div className = "form-content">
                    <p>{this.props.item.description}</p>
                    {this.renderModifications()}
                    {this.renderRestrictions()}
                  </div>
                  <div className = "form-submit">
                    {this.props.allowOrders && <button type = "submit" className = "form-submit-button">Order Now</button>}
                  </div>
              </form>
          </div>)}
          </Transition>
          </div>
        );
    }
  }
